import { DomainNamesDateRangeFilter } from './@component/DomainNamesDateRangeFilter';

export const ScannedDateFilter = () => {
  return (
    <DomainNamesDateRangeFilter
      startDateKey="scanned_date_start"
      endDateKey="scanned_date_end"
      label="Scanned date"
      logType="scanned date"
    />
  );
};
